import { render, staticRenderFns } from "./GenreDetails.vue?vue&type=template&id=c3992bf6"
import script from "./GenreDetails.vue?vue&type=script&lang=js"
export * from "./GenreDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports